// Comparador de dos fotos. El tirador es un <input type="range"> de verdad:
// se arrastra con el dedo, se mueve con las flechas del teclado y los lectores
// de pantalla lo anuncian. Este archivo solo copia su valor a una variable CSS.
//
// COMO SE MUEVE (reescrito el 2026-09-24, el de antes brincaba):
//   · Arrastrando, cero transicion. La foto va pegada al dedo, no persiguiendolo.
//   · Para todo lo demas —un toque en un lado de la foto, las flechas del teclado y el
//     vaiven de entrada— la posicion se interpola con la curva del CSS.
//   · La distincion se hace en el PRIMER MOVIMIENTO del puntero, no en el pointerdown:
//     asi un toque sin arrastre se desliza hasta el punto tocado, que es la mitad de la
//     gracia. En cuanto el dedo se mueve, el suavizado se apaga.
//
// Que esto funcione depende de que `--aud-agua-pos` este registrada con @property en el
// CSS de la seccion. Una propiedad personalizada sin registrar NO se anima: salta. Ese
// era el brinco, y el `transition` que ponia este archivo no hacia nada.
//
// Y da UNA pista: la primera vez que la banda entra en pantalla, el comparador se abre un
// poco y vuelve. Se salta entero con prefers-reduced-motion y no vuelve a ocurrir.
class AudAgua extends HTMLElement {
  connectedCallback() {
    const rango = this.querySelector('input[type="range"]');
    if (!rango) return;
    const pintar = () => this.style.setProperty('--aud-agua-pos', rango.value + '%');
    rango.addEventListener('input', pintar);
    rango.addEventListener('change', pintar);
    pintar();

    let abajo = false;
    const soltar = () => {
      abajo = false;
      this.classList.remove('is-arrastrando');
    };
    rango.addEventListener('pointerdown', () => {
      abajo = true;
    });
    rango.addEventListener('pointermove', () => {
      if (abajo) this.classList.add('is-arrastrando');
    });
    window.addEventListener('pointerup', soltar);
    window.addEventListener('pointercancel', soltar);

    const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (quieto || !('IntersectionObserver' in window)) return;

    const ojo = new IntersectionObserver((entradas) => {
      for (const e of entradas) {
        if (!e.isIntersecting) continue;
        ojo.disconnect();
        this.pista(rango, pintar);
      }
    }, { threshold: 0.4 });
    ojo.observe(this);
  }

  // UN SOLO viaje de ida y vuelta, largo y frenando por los dos lados. El vaiven de antes
  // daba tres tirones de 520 ms y se leia como un tic; este se lee como una invitacion.
  // Curva propia: la pista sale de quieto y acaba quieta, asi que no vale la del CSS, que
  // esta hecha para responder a un dedo. Las dos variables se devuelven al terminar.
  pista(rango, pintar) {
    const inicio = Number(rango.value);
    this.style.setProperty('--aud-agua-curva', 'cubic-bezier(0.65, 0, 0.35, 1)');
    const mover = (valor, ms) => {
      this.style.setProperty('--aud-agua-suave', ms + 'ms');
      rango.value = String(Math.max(0, Math.min(100, Math.round(valor))));
      pintar();
    };
    setTimeout(() => mover(inicio + 16, 900), 420);
    setTimeout(() => mover(inicio, 1100), 1440);
    setTimeout(() => {
      this.style.removeProperty('--aud-agua-suave');
      this.style.removeProperty('--aud-agua-curva');
    }, 2600);
  }
}
if (!customElements.get('aud-agua')) customElements.define('aud-agua', AudAgua);
